import axios from 'axios';
import {
  COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_BEGIN,
  COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_SUCCESS,
  COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_FAILURE,
  COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadProjectCollectionDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_BEGIN,
    });

    const { collectionId, projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${collectionId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectCollectionDetailError() {
  return {
    type: COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_BEGIN:
      return {
        ...state,
        loadProjectCollectionDetailPending: true,
        loadProjectCollectionDetailError: null,
      };

    case COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_SUCCESS:
      return {
        ...state,
        loadProjectCollectionDetailPending: false,
        loadProjectCollectionDetailError: null,
        selectedCollection: action.data,
        metaDataTableMappings: action.data.metaDataTableMapping || [],
        derivedFieldMapping: action.data.derivedFieldMapping || [],
      };

    case COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_FAILURE:
      return {
        ...state,
        loadProjectCollectionDetailPending: false,
        loadProjectCollectionDetailError: action.data.error,
      };

    case COLLECTIONS_LOAD_PROJECT_COLLECTION_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        loadProjectCollectionDetailError: action.data,
      };

    default:
      return state;
  }
}
